import React from 'react';
import MaskedInput from 'react-text-mask';
import {createNumberMask} from 'text-mask-addons';

import {CURRENCY_MASK_OPTIONS} from '../../../constants';
import BaseInput from '../../atoms/BaseInput';

export interface InputCurrencyProps {
  hideSymbol?: boolean;
  allowDecimal?: boolean;
  innerRef?: React.LegacyRef<MaskedInput>;
  maxLength?: number;
}

class InputCurrency extends BaseInput<InputCurrencyProps> {
  mask = createNumberMask({
    ...CURRENCY_MASK_OPTIONS,
    ...(this.props.hideSymbol && {prefix: ''}),
    allowDecimal: this.props.allowDecimal,
  });

  isValidCurrency = (currency: string): void => {
    if (typeof currency === 'undefined') {
      this.validState(true);

      return;
    }

    const isValid = currency.length <= 9;

    this.validState(isValid);
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const {onChange} = this.props;

    this.isValidCurrency(e.target.value);

    onChange?.(e);
  };

  render(): React.ReactElement {
    const {innerRef, id, autoComplete, maxLength = 12} = this.props;

    return (
      <MaskedInput
        id={id}
        inputMode="numeric"
        maxLength={maxLength}
        onChange={this.handleChange}
        autoComplete={autoComplete}
        ref={innerRef}
        guide
        mask={this.mask}
        render={(ref, renderProps) => {
          return this.renderBaseComponent(ref, renderProps);
        }}
      />
    );
  }
}

export default InputCurrency;
